import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { DealerAccountRequestModel } from "@insite/client-framework/Types/ApiModels";
import { submitDealerAccountRequest } from "@sonic/Services/DealerAccountService";
import { customerActions, customerState } from "@sonic/Store/GemecoState";
import { DispatchProp } from "react-redux";

type SubmitDealerAccountReuqestFormParameter = HasOnSuccess & HasOnError & DealerAccountRequestModel;

type HandlerType = ApiHandler<
    SubmitDealerAccountReuqestFormParameter,
    DealerAccountRequestModel,
    {
        apiCallIsSuccessful: boolean;
        getState: () => customerState;
    } & DispatchProp<customerActions>
>;

export const PopulateApiParameter: HandlerType = props => {
    const requestFormState = props.getState().dealerAccountRequestForm;
    props.apiParameter = {
        FirstName: requestFormState.fieldValues["firstName"],
        LastName: requestFormState.fieldValues["lastName"],
        BusinessName: requestFormState.fieldValues["businessName"],
        AddressLine1: requestFormState.fieldValues["addressLine1"],
        AddressLine2: requestFormState.fieldValues["addressLine2"],
        City: requestFormState.fieldValues["city"],
        StateProvince: requestFormState.fieldValues["stateProvince"],
        ZipPostcode: requestFormState.fieldValues["zipPostcode"],
        Country: requestFormState.fieldValues["country"],
        PhoneNumber: requestFormState.fieldValues["phoneNumber"],
        FaxNumber: requestFormState.fieldValues["faxNumber"],
        CompanyEmail: requestFormState.fieldValues["companyEmail"],
        CompanyWebsite: requestFormState.fieldValues["companyWebsite"],
        BusinessType: requestFormState.fieldValues["businessType"],
        BusinessDescription: requestFormState.fieldValues["businessDescription"],
        FederalTaxId: requestFormState.fieldValues["federalTaxId"],
        StateSalesTaxNumber: requestFormState.fieldValues["stateSalesTaxNumber"],
    };
};

export const SendDataToApi: HandlerType = async props => {
    try {
        await submitDealerAccountRequest(props.apiParameter);
        props.apiCallIsSuccessful = true;
    } catch (ex) {
        props.apiCallIsSuccessful = false;
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiCallIsSuccessful) {
        props.parameter.onError?.();
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const ClearFormState: HandlerType = props => {
    props.dispatch({ type: "Components/DealerAccountRequestForm/ClearForm" });
};

export const chain = [
    PopulateApiParameter,
    SendDataToApi,
    ExecuteOnErrorCallback,
    ExecuteOnSuccessCallback,
    ClearFormState,
];

const submitDealerAccountRequestForm = createHandlerChainRunner(chain, "SubmitDealerAccountRequestForm");
export default submitDealerAccountRequestForm;
